import React from "react";
import GitHubButton from "react-github-btn";

const Footer = () => {
    return (
        <div className="Footer">
            <div className="text">
                Made with{" "}
                <span role="img" aria-label="f" aria-labelledby="f">
                    💖
                </span>{" "}
                by <a href="/">Bagru Bois</a>
            </div>

            <span className="margin-left">
                <GitHubButton
                    href="https://github.com/radioactive11/AQUA/"
                    data-icon="octicon-star"
                    data-size="large"
                    aria-label="Star amanjagdev/aqua on GitHub"
                >
                    Star
                </GitHubButton>
            </span>

            <span className="margin-left" style={{ marginInline: "1rem" }}>
                or
            </span>

            <span className="margin-left">
                <GitHubButton
                    href="https://github.com/radioactive11/AQUA"
                    data-icon="octicon-repo-forked"
                    data-size="large"
                    aria-label="Fork amanjagdev/aqua on GitHub"
                >
                    Fork
                </GitHubButton>
            </span>
        </div>
    );
};

export default Footer;
